// extracted by mini-css-extract-plugin
export var button = "_by-4";
export var hasDarkBackground = "_by-7";
export var hasLightBackground = "_by-6";
export var iconWrapper = "_by-0";
export var large = "_by-2";
export var medium = "_by-1";
export var small = "_by-5";
export var xsmall = "_by-3";